import React, { Suspense, useState, useEffect } from 'react';
import SuspenseComponent from '../../../views/components/SuspenseComponent';
import RatingsTable from './RatingsTable';
import RatingsSubmitDateRange from './RatingsSubmitDateRange';
import RatingsSubmitSerial from './RatingsSubmitSerial';
import RatingsSubmitDevices from './RatingsSubmitDevices';
import { getDeviceRatingsByRange , getDeviceRatings } from "API";
import { useMutation, useQueryClient, } from 'react-query'
import { Row, Col } from "reactstrap";
const Ratings = (props) => {
    const [valueDateRange, setValueDateRange] = useState(null);
    const [serial, setSerial] = useState(null);
    const [dateStart, setDateStart] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);

    const [loading, setLoading] = useState(null);
    const queryClient = useQueryClient()

    const handleSubmit = () => {
        setLoading(true);
        if (dateStart instanceof Date && dateEnd instanceof Date) {
            mutation({ startRange: dateStart, endRange: dateEnd, serial });
        } else if (serial !== null) {
            mutation({ startRange: null, endRange: null, serial });
        } else {
            mutationPlain();
        }
    };

    const handleSetValueDateRange = (value) => {
        setDateStart(value?.[0] ?? null);
        setDateEnd(value?.[1] ?? null);
        setValueDateRange(value);
    };

    const handleResetDateRange = () => {
        setDateStart(null);
        setDateEnd(null);
        setValueDateRange(null);
        setLoading(true);
        mutationPlain();
    };

    const handleResetSerial = () => {
        setSerial(null);
    };

    const { mutate: mutation } = useMutation(
        {
            mutationFn: getDeviceRatingsByRange,
            onSuccess: async (newData) => {

                setLoading(false);
                queryClient.setQueryData("RatingsData", newData);
            }
        }
    );

    const { mutate: mutationPlain } = useMutation(
        {
            mutationFn: getDeviceRatings,
            onSuccess: async (newData) => {

                setLoading(false);
                queryClient.setQueryData("RatingsData", newData);
            }
        }
    );

    useEffect(() => {
        setLoading(true);
        mutationPlain();
    }, [mutationPlain]);

    return (
        <>
            <div className="content">
                <Row>
                    <Col lg="3">
                        <h4>
                            Return Person
                        </h4>
                    </Col>
                </Row>
                <Row>
                    <RatingsSubmitDateRange handleSetValueDateRange={handleSetValueDateRange} valueDateRange={valueDateRange} handleSubmit={handleSubmit} handleResetDateRange={handleResetDateRange} />
                    <RatingsSubmitSerial serial={serial} setSerial={setSerial} handleResetSerial={handleResetSerial} handleSubmit={handleSubmit} />
                    {/* <RatingsSubmitDevices handleSubmit={handleSubmit} /> */}
                </Row>

                <Suspense fallback={<SuspenseComponent />}>
                    <RatingsTable loading={loading} valueDateRange={valueDateRange} serial={serial} />
                </Suspense>
            </div>
        </>
    );
};

export default Ratings;
